import React from "react";
import { PROFILE } from "@/data/portfolio";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-background">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <hr className="rule" />
        <p className="text-sm text-quiet flex flex-wrap items-center justify-between gap-3">
          <span>
            &copy; {year} {PROFILE.name}. Last updated {new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}.
          </span>
          <a
            href="#top"
            data-testid="back-to-top"
            className="link"
          >
            back to top ↑
          </a>
        </p>
      </div>
    </footer>
  );
};
